<template>
  <div class="home">
    <div class="section">
      <div class="container is-fluid">
        <div class="columns">
          <div class="column is-4 is-2-widescreen">
            <Menu></Menu>
          </div>
          <div class="column">
            <Content></Content>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Copyright (c) 2019. Filip Conka <filip@conka.pro>
 */
import Menu from '../components/organisms/Menu'
import Content from '../components/organisms/Content'

import { mapGetters } from 'vuex'

export default {
  name: 'home',
  components: {
    Content,
    Menu
  },
  data () {
    return {
      currentTerritoryId: null,
      subscribed: false
    }
  },
  computed: {
    ...mapGetters('territories', {
      territories: 'getTerritories'
    }),
    ...mapGetters({
      isWebSocketConnected: 'isConnected'
    }),
    ...mapGetters('tag', {
      tagId: 'getTagId'
    })
  },
  watch: {
    isWebSocketConnected (newValue) {
      console.log(newValue)
      if (newValue === false) { return }

      this.subscribeTerritories()
    }
  },
  methods: {
    subscribeTerritories () {
      for (let key in this.territories) {
        this.$socket.sendObj({ 'headers': { 'X-ApiKey': '171555a8fe71148a165392904' }, 'method': 'subscribe', 'resource': '/zones/' + this.territories[key].localityId })
      }
      this.subscribed = true
    }
  },
  mounted () {
    if (this.tagId === null) {
      this.$router.push('/')
    }
    if (!this.subscribed && this.isWebSocketConnected) {
      this.subscribeTerritories()
      this.subscribed = true
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  padding-top: 0;
  &> .section {
    padding-top: 0;
  }
}
</style>
